var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSimulationCalenderIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.833333 0.833008H8.33333C8.795 0.833008 9.16667 1.20467 9.16667 1.66634V3.74967H0V1.66634C0 1.20467 0.371667 0.833008 0.833333 0.833008Z",
    fill: "url(#paint0_linear_2406_3748)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 3.33301V9.16634C0 9.62801 0.371667 9.99967 0.833333 9.99967H8.33333C8.795 9.99967 9.16667 9.62801 9.16667 9.16634V3.33301H0Z",
    fill: "url(#paint1_linear_2406_3748)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.49984 0.416667C2.49984 0.186548 2.31329 0 2.08317 0C1.85305 0 1.6665 0.186548 1.6665 0.416667V2.08333C1.6665 2.31345 1.85305 2.5 2.08317 2.5C2.31329 2.5 2.49984 2.31345 2.49984 2.08333V0.416667Z",
    fill: "#34485C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.49984 0.416667C7.49984 0.186548 7.31329 0 7.08317 0C6.85305 0 6.6665 0.186548 6.6665 0.416667V2.08333C6.6665 2.31345 6.85305 2.5 7.08317 2.5C7.31329 2.5 7.49984 2.31345 7.49984 2.08333V0.416667Z",
    fill: "#34485C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.49984 4.16699H6.6665V5.00033H7.49984V4.16699Z",
    fill: "#A5B7BF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.83333 4.16699H5V5.00033H5.83333V4.16699Z",
    fill: "#A5B7BF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M4.16683 4.16699H3.3335V5.00033H4.16683V4.16699Z",
    fill: "#A5B7BF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M2.49984 4.16699H1.6665V5.00033H2.49984V4.16699Z",
    fill: "url(#paint2_linear_2406_3748)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M7.49984 5.83301H6.6665V6.66634H7.49984V5.83301Z",
    fill: "#A5B7BF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M5.83333 5.83301H5V6.66634H5.83333V5.83301Z",
    fill: "#A5B7BF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M4.16683 5.83301H3.3335V6.66634H4.16683V5.83301Z",
    fill: "#A5B7BF"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M2.49984 5.83301H1.6665V6.66634H2.49984V5.83301Z",
    fill: "#A5B7BF"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M5.83333 7.5H5V8.33333H5.83333V7.5Z",
    fill: "#A5B7BF"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M4.16683 7.5H3.3335V8.33333H4.16683V7.5Z",
    fill: "#A5B7BF"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M2.49984 7.5H1.6665V8.33333H2.49984V7.5Z",
    fill: "#A5B7BF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2406_3748",
    x1: 0,
    y1: 2.29134,
    x2: 9.16667,
    y2: 2.29134,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC6A28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F94045"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2406_3748",
    x1: 0,
    y1: 6.66634,
    x2: 9.16667,
    y2: 6.66634,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DFE3E4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2406_3748",
    x1: 1.6665,
    y1: 4.58366,
    x2: 2.49984,
    y2: 4.58366,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5B7BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A5B7BF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSimulationCalenderIcon);
export default __webpack_public_path__ + "static/media/simulationCalenderIcon.e3f199c7b77fdcba09c6135c2d6ab7e2.svg";
export { ForwardRef as ReactComponent };